import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=0ea8f75c"
import script from "./grid.ts?vue&type=script&lang=js&external"
export * from "./grid.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea8f75c')) {
      api.createRecord('0ea8f75c', component.options)
    } else {
      api.reload('0ea8f75c', component.options)
    }
    module.hot.accept("./grid.vue?vue&type=template&id=0ea8f75c", function () {
      api.rerender('0ea8f75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/grid/grid.vue"
export default component.exports